import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Suppliers from "@/pages/Suppliers";
import Templates, { TemplateEditor } from "@/pages/Templates";
import Orders, { NewOrder } from "@/pages/Orders";
import SmtpSettings from "@/pages/SmtpSettings";
import { AppConfigProvider } from "@/lib/AppConfigContext";

function App() {
  return (
    <div className="App">
      <AppConfigProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/proveedores" element={<Suppliers />} />
              <Route path="/plantillas" element={<Templates />} />
              <Route path="/plantillas/nueva" element={<TemplateEditor />} />
              <Route path="/plantillas/:id" element={<TemplateEditor />} />
              <Route path="/pedidos" element={<Orders />} />
              <Route path="/pedidos/nuevo" element={<NewOrder />} />
              <Route path="/pedidos/:id/editar" element={<NewOrder />} />
              <Route path="/configuracion" element={<SmtpSettings />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AppConfigProvider>
    </div>
  );
}

export default App;
